function getYoutubeId(url) {
    try {
        return new URL(url).searchParams.get('v');
    } catch {
        return null;
    }
}

function Poster({ info }) {
    if (!info) return null;

    const { background, backgroundType, heading, subheading } = info.extra || {};

    const renderBackground = () => {
        if (backgroundType === 'youtube-video') {
            const videoId = getYoutubeId(background);
            if (!videoId) return null;
            const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&playsinline=1&rel=0`;
            return (
                <iframe
                    className="poster-video"
                    src={src}
                    title="background video"
                    allow="autoplay; fullscreen"
                    frameBorder="0"
                />
            );
        }
        if (backgroundType === 'image' && background) {
            return <div className="poster-image" style={{ backgroundImage: `url(${background})` }} />;
        }
        return null;
    };

    return (
        <div className="poster">
            <div className="poster-background">
                {renderBackground()}
            </div>
            <div className="poster-overlay">
                {heading && <h1 className="poster-heading">{heading}</h1>}
                {subheading && <p className="poster-subheading">{subheading}</p>}
            </div>
        </div>
    );
}

export default Poster;
